import "./fpp-app/layout/container.css";
import { startLoginFlow } from "./login-flow/flow";
import { addErrorHandler, getAppStatus } from "single-spa";
import { FppBackendLogger } from "@newsenec/logging";
import { loadConfigurationFromBackend } from "@newsenec/configuration-provider";
import { removeErrorPage, showErrorNav, showErrorPage } from "./fpp-app/error/errorView";
import { documentTitles } from "./constants";
import { isAppControl } from "@newsenec/auth-provider";

loadConfigurationFromBackend().then((config) => {
    let title = isAppControl() ? documentTitles.control : documentTitles.cockpit;
    if (config.environment === "pg" || config.environment === "qa") {
        title += ` ${config.environment.toUpperCase()}`;
    }
    document.title = title;
});

addErrorHandler((err) => {
    const mf = err.appOrParcelName;

    // log microfrontend lifecycle errors to backend
    const logger = new FppBackendLogger(mf, mf);
    logger.logError(getAppStatus(mf)!, err.stack);

    if (mf === "@newsenec/navigation" || mf === "@newsenec/footer") {
        showErrorNav(mf);
        return;
    }

    showErrorPage();
});

window.addEventListener("single-spa:before-routing-event", () => {
    removeErrorPage();
});

startLoginFlow();
